module.exports = __webpack_public_path__ + "img/bw.21d13bb8.gif";